import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Chart } from 'chart.js/auto';

import { AppServices } from '../../../services/appServices';
import { reportGrainMetricValue } from '../../../models/reportGrainMetricValue';

@Component({
  selector: 'app-grain-metric-value-barchart',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="chart-container">
      <canvas #chartCanvas></canvas>
    </div>
  `,
  styles: [`
    .chart-container {
      position: relative;
      width: 100%;
      height: 420px;
    }
  `]
})
export class GrainMetricValueBarChart implements OnInit, AfterViewInit, OnChanges {
  constructor(private appServices: AppServices) {}

  @ViewChild('chartCanvas') chartCanvas!: ElementRef<HTMLCanvasElement>;

  private chart: Chart | null = null;
  private viewReady = false;

  reportData: reportGrainMetricValue[] = [];
  reportId: string = 'SHOTCATEGORYBYMOTH';

  ngOnInit(): void {
    this.getReport();
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.viewReady) {
      this.renderChart();
    }
  }

  async getReport() {
    const username = this.getUsername();
    if (!username) return;

    this.reportData = await this.appServices.reportingService.getGrainMetricValueReport(
      username,
      this.reportId
    );
  }

  getUsername(): string | null {
    return this.appServices.authenticationService.loggedInUser?.username ?? null;
  }

  private async renderChart(): Promise<void> {
    if (!this.chartCanvas) return;

    await this.getReport();

    const months = [
      ...new Map(
        this.reportData
          .sort((a, b) => a.sort_order - b.sort_order)
          .map(item => [item.grain_value, item.grain_value])
      ).values()
    ];

    const buildSeries = (label: string) =>
      months.map(month => {
        const match = this.reportData.find(
          x => x.metric_label === label && x.grain_value === month
        );
        return match?.metric_value ?? 0;
      });

    const chartData = {
      labels: months,
      datasets: [
        {
          label: 'Good',
          data: buildSeries('GOOD'),
          backgroundColor: '#90ee90',
          borderColor: '#90ee90',
          borderWidth: 1
        },
        {
          label: 'Average',
          data: buildSeries('AVERAGE'),
          backgroundColor: '#87ceeb',
          borderColor: '#87ceeb',
          borderWidth: 1
        },
        {
          label: 'Bad',
          data: buildSeries('BAD'),
          backgroundColor: '#D66A6A',
          borderColor: '#D66A6A',
          borderWidth: 1
        },
        {
          label: 'Make',
          data: buildSeries('MAKE'),
          backgroundColor: '#62ad62',
          borderColor: '#62ad62',
          borderWidth: 1
        },
        {
          label: 'Miss',
          data: buildSeries('MISS'),
          backgroundColor: '#bb4545',
          borderColor: '#bb4545',
          borderWidth: 1
        },

      ]
    };

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(this.chartCanvas.nativeElement, {
      type: 'bar',
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          },
          title: {
            display: true,
            text: 'Shot Quality Progress'
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            min: 0,
            ticks: {
              precision: 0,
              stepSize: 1
            },
            title: {
              display: true,
              text: 'Count'
            }
          },
          x: {
            title: {
              display: true,
              text: 'Month'
            }
          }
        }
      }
    });
  }
}